// This file was auto-generated by Fern from our API Definition.
export const Focus = {
    Trace: "trace",
    Span: "span",
};
